require("normalize.css");
require("./overview.scss");

/** Time (ms) to wait until next scroll event is emitted */
const SCROLL_DELAY = 1000;

/** class-name of the 'prev' fade animation */
const FADE_PREV = "fade-left";

/** class-name of the 'next' fade animation */
const FADE_NEXT = "fade-right";

let currentBook = 1;
let books = [];

/**
 * When the page is loaded, the books-array is initialized
 * and the onclick-functions for the "next" and "prev" buttons
 * are set.
 */
window.onload = function () {
  books = Array.from(document.getElementsByClassName("book"));
  showBook(currentBook);

  configureControlButtons();

  addSwipeListener();

  addScrollWheelListener();

  addKeyboardListener();
};

function configureControlButtons() {
  document.getElementById("book-prev").onclick = () => {
    prevBook();
    return false;
  };
  document.getElementById("book-next").onclick = () => {
    nextBook();
    return false;
  };
}

function addSwipeListener() {
  const manager = new Hammer(document.body);

  manager.on("swipeleft", function () {
    nextBook();
  });
  manager.on("swiperight", function () {
    prevBook();
  });
}

function addKeyboardListener() {
  window.addEventListener("keydown", (event) => {
    if (event.isComposing || event.code === 229) {
      return;
    }
    switch (event.code) {
      case "ArrowRight":
        nextBook();
        break;
      case "ArrowLeft":
        prevBook();
        break;
      default:
        break;
    }

    return;
  });
}

/**
 * Register the scroll wheel listener and throttle it (using lodash)
 */
function addScrollWheelListener() {
  window.addEventListener(
    "wheel",
    _.throttle(
      (event) => {
        const scrolledUp = event.deltaY < 0;

        if (scrolledUp) {
          prevBook();
        } else {
          nextBook();
        }
      },
      SCROLL_DELAY,
      {trailing: false}
    )
  );
}

/**
 * Shows one specific book from the books-array.
 *
 * @param {number} index The index of the book to show
 */
function showBook(index) {
  if (index > books.length) {
    currentBook = 1;
  }
  if (index < 1) {
    currentBook = books.length;
  }

  books.forEach((e) => (e.style.display = "none"));
  books[currentBook - 1].style.display = "flex";
}

/**
 * Replaces class names in an array of HTMLElements.
 * Appends the class name if the one to replace is not present
 *
 * @param {Array<HTMLElement>} elements Elements to iterate
 * @param {String} sOld Classname to be replace
 * @param {String} sNew Replacement classname
 */
function _replaceClassNames(elements, sOld, sNew) {
  elements.forEach((e) => {
    if (e.className.includes(sOld)) {
      e.className = e.className.replace(sOld, sNew);
    } else if (!e.className.includes(sNew)) {
      e.className += " " + sNew;
    }
  });
}

const setFadeDirectionNext = () => _replaceClassNames(books, FADE_PREV, FADE_NEXT);
const setFadeDirectionPrev = () => _replaceClassNames(books, FADE_NEXT, FADE_PREV);

/**
 * Advances the shown book by one.
 */
function nextBook() {
  setFadeDirectionNext();
  showBook((currentBook += 1));
}

/**
 * Reverts to the previously shown book.
 */
function prevBook() {
  setFadeDirectionPrev();
  showBook((currentBook -= 1));
}
